import { isClient } from '@/utils/isClient';
import { logger } from '@/utils/logger';
import { useCallback, useMemo } from 'react';

export type EcommerceItem = {
  item_id: string;
  item_name: string;
  item_category?: string;
  price?: number;
  quantity?: number;
};

type PurchaseDataLayerPayload = {
  event: 'purchase';
  ecommerce: {
    currency: string;
    value: number;
    transaction_id: string;
    subscription_id: string;
    items: EcommerceItem[];
  };
};

type ViewPromotionDataLayerPayload = {
  event: 'view_promotion';
  ecommerce: {
    currency: string;
    value: number;
    promotion_id: string;
    promotion_name: string;
    items: EcommerceItem[];
  };
};

type BeginCheckoutDataLayerPayload = {
  event: 'begin_checkout';
  ecommerce: {
    currency: string;
    value: number;
    items: EcommerceItem[];
  };
};

type DataLayerPayload =
  | PurchaseDataLayerPayload
  | ViewPromotionDataLayerPayload
  | BeginCheckoutDataLayerPayload;

const useWindowDataLayer = () => {
  const push = useCallback((payload: DataLayerPayload) => {
    try {
      if (isClient()) {
        window.dataLayer ??= [];
        window.dataLayer.push(payload);
      }
    } catch (e) {
      logger.error('Cannot push data to window.dataLayer');
    }
  }, []);

  return useMemo(() => ({ push }), [push]);
};

export default useWindowDataLayer;
